export default {
  submit: "提交",
  save: "保存",
  "submit.ok": "提交成功",
  "save.ok": "保存成功",
  please_input: "请填写此栏",
  please_select: "请选择",
  operation_succeeded: "操作成功"
};
